<template>
  <div>
    <el-card>
      <div class="flex flex-between panel-header">
        <div>
          <el-button size="small" @click="syncCoupon" type="primary"
            >同步数据</el-button
          >
          <el-button
            size="small"
            @click="relate"
            type="primary"
            :disabled="checkedRow.length <= 0"
            >批量关联</el-button
          >
        </div>
        <div>
          <el-select
            size="small"
            v-model="relateStatus"
            placeholder="选择关联状态"
            clearable
          >
            <el-option label="全部" value=" "></el-option>
            <el-option label="已关联" :value="1"></el-option>
            <el-option label="未关联" :value="0"></el-option>
          </el-select>
          <el-input
            size="small"
            placeholder="请输入券名"
            clearable
            v-model.trim="couponName"
          ></el-input>
          <el-button
            size="small"
            @click="reset"
            class="hmicon icon-zhongzhi reset"
            :disabled="this.relateStatus === '' && this.couponName === ''"
          ></el-button>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <div class="send-table">
          <el-table
            border
            :data="relateCoupons"
            style="width: 100%"
            @selection-change="getChecked"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="selection"
              width="50"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="typeId"
              label="类型ID"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="typeName"
              label="类型名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="同步时间"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="关联状态"
            >
              <template slot-scope="scope">
                <span v-show="scope.row.link === '0'">未关联</span>
                <span class="related" v-show="scope.row.link !== '0'"
                  >已关联</span
                >
              </template>
            </el-table-column>
            <el-table-column header-align="center" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="relateSingle(scope.row.typeId)"
                  :disabled="scope.row.link === '1'"
                >
                  关联
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="table-footer text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="relateCouponsTotal"
          @current-change="paging"
          :current-page="currentPage"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      detail: [],
      currentPage: 1,
      checkedRow: [],
      relateStatus: "",
      couponName: ""
    };
  },

  components: {},

  created() {
    this.getAllRelateRule();
  },

  mounted() {},

  computed: {
    relateCoupons() {
      const data = this.$store.state.rules.relateCoupons;
      data.forEach(v => {
        v.createTime = moment(v.createTime).format("YYYY-MM-DD HH:mm:ss");
      });
      return data;
    },
    relateCouponsTotal() {
      return this.$store.state.rules.relateCouponsTotal;
    },
    relateRuleCode() {
      return this.$store.state.rules.relateRuleCode;
    },
    syncCouponCode() {
      return this.$store.state.rules.syncCouponCode;
    }
  },

  watch: {
    relateRuleCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.getAllRelateRule();
      }
      this.$store.commit("relateRule", "");
    },
    syncCouponCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.getAllRelateRule();
      }
      this.$store.commit("syncCoupon", "");
    }
  },

  methods: {
    reset() {
      this.relateStatus = "";
      this.couponName = "";
    },
    paging(page) {
      this.currentPage = page;
      this.getAllRelateRule();
    },
    search() {
      this.getAllRelateRule();
    },
    relate() {
      const ids = [];
      this.checkedRow.forEach(v => {
        ids.push(v.typeId);
      });
      this.$store.dispatch("relateRule", {
        ids: ids
      });
    },
    relateSingle(id) {
      this.$store.dispatch("relateRule", {
        ids: [id]
      });
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    syncCoupon() {
      this.$store.dispatch("syncCoupon");
    },
    getAllRelateRule() {
      this.$store.dispatch("queryRelateRule", {
        pageNo: this.currentPage,
        link: this.relateStatus,
        typeName: this.couponName
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table-footer {
  margin-top: 10px;
}
.related {
  color: #c0c4cc;
}
.panel-header {
  margin-bottom: 10px;
}
</style>
